var React = require('react');

function Refresh (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.4 5.7L18 3.8l-5.9-1 2.1 5.6 1.5-1.8c.3.6.5 1.3.6 1.9.3 1.8-.2 3.5-1.2 5-1.1 1.4-2.6 2.4-4.4 2.7-3.7.6-7.1-1.9-7.7-5.6-.3-2.5.7-4.9 2.6-6.4l.4-.3-.6-.8-.4.3c-2.3 1.7-3.4 4.5-3 7.3.6 3.8 3.9 6.5 7.6 6.5.4 0 .8 0 1.2-.1 2-.3 3.8-1.4 5-3.1 1.2-1.7 1.7-3.7 1.4-5.7 0-.9-.3-1.8-.8-2.6z"}));
}

Refresh.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Refresh;

Refresh.default = Refresh;
